import * as styles from "../../../../../styles/WholedataPage";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import { RootState } from "reducer";

const GROWTH = ({ setPutdata, putdata, setBodydata, TargetDiaryAct }: any) => {
  const { TargetDiary } = useSelector((state: RootState) => state.post);
  const [inputValues, setInputValues] = useState<any>({
    wormWeight: { diaryContentId: 0, value: "" },
    wormLength: { diaryContentId: 0, value: "" },
    detectingCount: { diaryContentId: 0, value: "" },
    maxWormLength: { diaryContentId: 0, value: "" },
    minWormLength: { diaryContentId: 0, value: "" },
    // wormHeadSize: { diaryContentId: 0, value: "" },
  });

  useEffect(() => {
    putdata &&
      putdata.map((item: any, idx: Number) => {
        Object.keys(inputValues).map((inputkey) => {
          if (item.diaryItem.name === inputkey) {
            let updatedInputValues = { ...inputValues };
            updatedInputValues[inputkey].diaryContentId = item.diaryContentId;
            updatedInputValues[inputkey].value = item.value;
            updatedInputValues[inputkey].diaryItem = item.diaryItem;
            setInputValues(updatedInputValues);
            setBodydata({ ...inputValues });
          }
        });
      });
  }, [TargetDiary, putdata, TargetDiaryAct, inputValues, setBodydata]);

  const InputHandler = (e: any) => {
    const { name, value } = e.target;
    setInputValues({
      ...inputValues,
      [name]: { ...inputValues[name], value },
    });
  };
  useEffect(() => {
    setBodydata({ ...inputValues });
  }, [inputValues, setBodydata]);

  return (
    <styles.WorkItemBox>
      <styles.WorkItem>
        <div className="work-item-top">
          {/* {console.log("inputValues", inputValues)} */}
          <p className="work-item-title">
            {" "}
            {inputValues.wormWeight.diaryItem?.note}
          </p>

          <p className="work-item-unit">
            {" "}
            {inputValues.wormWeight.diaryItem?.unit}
          </p>
        </div>
        <input
          type="text"
          style={{
            background:
              inputValues?.soilWeight?.diaryItem?.writable === "N"
                ? "#dddddd"
                : "transparent",
          }}
          value={inputValues.wormWeight.value}
          data-Id=""
          name="wormWeight"
          onChange={InputHandler}
          readOnly={inputValues?.wormWeight?.diaryItem?.writable !== "Y"}
        />
      </styles.WorkItem>
      <styles.WorkItem>
        <div className="work-item-top">
          <p className="work-item-title">
            {" "}
            {inputValues.wormLength.diaryItem?.note}
          </p>

          <p className="work-item-unit">
            {" "}
            {inputValues.wormLength.diaryItem?.unit}
          </p>
        </div>
        <input
          type="text"
          style={{
            background:
              inputValues?.wormLength?.diaryItem?.writable === "N"
                ? "#dddddd"
                : "transparent",
          }}
          value={inputValues.wormLength.value}
          data-Id=""
          name="wormLength"
          onChange={InputHandler}
          readOnly={inputValues?.wormLength?.diaryItem?.writable !== "Y"}
        />
      </styles.WorkItem>
      <styles.WorkItem>
        <div className="work-item-top">
          <p className="work-item-title">
            {inputValues.detectingCount.diaryItem?.note}
          </p>
          <p className="work-item-unit">
            {inputValues.detectingCount.diaryItem?.unit}
          </p>
        </div>
        <input
          type="text"
          style={{
            background:
              inputValues?.detectingCount?.diaryItem?.writable === "N"
                ? "#dddddd"
                : "transparent",
          }}
          value={inputValues.detectingCount.value}
          data-Id=""
          name="detectingCount"
          onChange={InputHandler}
          readOnly={inputValues?.detectingCount?.diaryItem?.writable !== "Y"}
        />
      </styles.WorkItem>
      <styles.WorkItem>
        <div className="work-item-top">
          <p className="work-item-title">
            {inputValues.maxWormLength.diaryItem?.note}
          </p>
          <p className="work-item-unit">
            {inputValues.maxWormLength.diaryItem?.unit}
          </p>
        </div>
        <input
          type="text"
          style={{
            background:
              inputValues?.maxWormLength?.diaryItem?.writable === "N"
                ? "#dddddd"
                : "transparent",
          }}
          value={inputValues.maxWormLength.value}
          data-Id=""
          name="maxWormLength"
          onChange={InputHandler}
          readOnly={inputValues?.maxWormLength?.diaryItem?.writable !== "Y"}
        />
      </styles.WorkItem>
      <styles.WorkItem>
        <div className="work-item-top">
          <p className="work-item-title">
            {inputValues.minWormLength.diaryItem?.note}
          </p>
          <p className="work-item-unit">
            {inputValues.minWormLength.diaryItem?.unit}
          </p>
        </div>
        <input
          type="text"
          value={inputValues.minWormLength.value}
          style={{
            background:
              inputValues?.minWormLength?.diaryItem?.writable === "N"
                ? "#dddddd"
                : "transparent",
          }}
          data-Id=""
          name="minWormLength"
          onChange={InputHandler}
          readOnly={inputValues?.minWormLength?.diaryItem?.writable !== "Y"}
        />
      </styles.WorkItem>
    </styles.WorkItemBox>
  );
};

const REPLACEFEED = ({
  setPutdata,
  putdata,
  setBodydata,
  calculation,
}: any) => {
  const { TargetDiary } = useSelector((state: RootState) => state.post);
  const [inputValues, setInputValues] = useState<any>({
    soilWeight: { diaryContentId: 0, value: "" },
    wormTotalWeight: { diaryContentId: 0, value: "" },
    totalFeedWeight: { diaryContentId: 0, value: "" },
    totalSoilWeight: { diaryContentId: 0, value: "" },
  });

  useEffect(() => {
    console.log("putdata:: ", putdata);
    putdata &&
      putdata.map((item: any, idx: Number) => {
        Object.keys(inputValues).map((inputkey) => {
          if (item.diaryItem.name === inputkey) {
            let updatedInputValues = { ...inputValues };
            updatedInputValues[inputkey].diaryContentId = item.diaryContentId;
            updatedInputValues[inputkey].value = item.value;
            updatedInputValues[inputkey].diaryItem = item.diaryItem;

            setInputValues(updatedInputValues);
            setBodydata({ ...inputValues });
          }
        });
      });
  }, [TargetDiary, inputValues, putdata, setBodydata]);

  const InputHandler = (e: any) => {
    const { name, value } = e.target;
    setInputValues({
      ...inputValues,
      [name]: { ...inputValues[name], value },
    });
  };
  useEffect(() => {
    setBodydata({ ...inputValues });
  }, [inputValues, setBodydata]);
  return (
    <>
      <styles.WorkItemBox></styles.WorkItemBox>
      <styles.WorkItemBox>
        <styles.WorkItem>
          <div className="work-item-top">
            <p className="work-item-title">
              {" "}
              {inputValues.soilWeight.diaryItem?.note}
            </p>
            <p className="work-item-unit">
              {inputValues.soilWeight.diaryItem?.unit}
            </p>
          </div>
          <input
            type="text"
            value={inputValues.soilWeight.value}
            style={{
              background:
                inputValues?.soilWeight?.diaryItem?.writable === "N"
                  ? "#dddddd"
                  : "transparent",
            }}
            data-Id=""
            name="soilWeight"
            onChange={InputHandler}
            readOnly={inputValues?.soilWeight?.diaryItem?.writable !== "Y"}
          />
        </styles.WorkItem>
        <styles.WorkItem>
          <div className="work-item-top">
            <p className="work-item-title">
              {/* 누적급이량 */} {inputValues.totalFeedWeight.diaryItem?.note}
            </p>
            <p className="work-item-unit">
              {/* (g) */} {inputValues.totalFeedWeight.diaryItem?.unit}
            </p>
          </div>
          <input
            type="text"
            style={{
              background:
                inputValues?.totalFeedWeight?.diaryItem?.writable === "N"
                  ? "#dddddd"
                  : "transparent",
            }}
            // style={{ background: "#dddddd" }}
            // value={calculation?.[0]?.totalFeedWeight}
            value={inputValues.totalFeedWeight.value}
            data-Id=""
            name="totalFeedWeight"
            onChange={InputHandler}
            readOnly={inputValues?.totalFeedWeight?.diaryItem?.writable !== "Y"}
          />
        </styles.WorkItem>
        <styles.WorkItem>
          <div className="work-item-top">
            <p className="work-item-title">
              {/* 누적분변토량 */} {inputValues.totalSoilWeight.diaryItem?.note}
            </p>
            <p className="work-item-unit">
              {/* (g) */} {inputValues.totalSoilWeight.diaryItem?.unit}
            </p>
          </div>
          <input
            type="text"
            style={{
              background:
                inputValues?.totalSoilWeight?.diaryItem?.writable === "N"
                  ? "#dddddd"
                  : "transparent",
            }}
            // style={{ background: "#dddddd" }}
            // value={calculation?.[0]?.totalSoilWeight}
            value={inputValues.totalSoilWeight.value}
            data-Id=""
            name="totalSoilWeight"
            onChange={InputHandler}
            readOnly={inputValues?.totalSoilWeight?.diaryItem?.writable !== "Y"}
          />
        </styles.WorkItem>
        <styles.WorkItem>
          <div className="work-item-top">
            <p className="work-item-title">
              {" "}
              {inputValues.wormTotalWeight.diaryItem?.note}
            </p>
            <p className="work-item-unit">
              {inputValues.wormTotalWeight.diaryItem?.unit}
            </p>
          </div>
          <input
            type="text"
            style={{
              background:
                inputValues?.wormTotalWeight?.diaryItem?.writable === "N"
                  ? "#dddddd"
                  : "transparent",
            }}
            value={inputValues.wormTotalWeight.value}
            data-Id=""
            name="wormTotalWeight"
            onChange={InputHandler}
            readOnly={inputValues?.wormTotalWeight?.diaryItem?.writable !== "Y"}
          />
        </styles.WorkItem>
      </styles.WorkItemBox>
    </>
  );
};

const CLEAN = ({ setPutdata, putdata, setBodydata }: any) => {
  const { TargetDiary } = useSelector((state: RootState) => state.post);
  const box1 = TargetDiary?.diaryContents[0].value === "1" ? true : false;
  const box2 = TargetDiary?.diaryContents[1].value === "1" ? true : false;
  let [ischecked, setIschecked] = useState<any>(false);

  const [inputValues, setInputValues] = useState<any>({
    cleanDate: { diaryContentId: 0, value: box1 },
  });

  const InputHandler = (e: any) => {
    if (e.target.name === "moveBox" && e.target.checked === true) {
      setIschecked(true);
    } else {
      setIschecked(false);
    }
    setInputValues({
      ...inputValues,
      [e.target.name]: {
        diaryContentId: parseInt(e.target.dataset.id),
        value:
          e.target.checked === null && undefined ? false : e.target.checked,
      },
    });
  };

  console.log("putdata :: ", putdata);
  useEffect(() => {
    putdata &&
      putdata.map((item: any, idx: Number) => {
        Object.keys(inputValues).map((inputkey) => {
          if (item.diaryItem.name === inputkey) {
            if (item.value === "1") {
              let updatedInputValues = { ...inputValues };
              updatedInputValues[inputkey].diaryContentId = item.diaryContentId;
              updatedInputValues[inputkey].value = true;
              setInputValues(updatedInputValues);
              setBodydata({ ...inputValues });
            } else {
              let updatedInputValues = { ...inputValues };
              updatedInputValues[inputkey].diaryContentId = item.diaryContentId;

              updatedInputValues[inputkey].value = false;
              setInputValues(updatedInputValues);
              setBodydata({ ...inputValues });
            }
          }
        });
      });
  }, [TargetDiary, inputValues, putdata, setBodydata]);

  useEffect(() => {
    setBodydata({ ...inputValues });
  }, [inputValues, setBodydata]);

  return (
    <styles.WorkItemBox>
      <styles.CleaningCheckBox>
        <label>
          <input
            id="cleanDate"
            checked={inputValues.cleanDate.value === true ? true : false}
            value=""
            type="checkbox"
            data-Id={parseInt(putdata?.[2]?.diaryContentId)}
            name="cleanDate"
            onChange={InputHandler}
          />
          청소
        </label>
      </styles.CleaningCheckBox>
    </styles.WorkItemBox>
  );
};

const FEED = ({
  TargetDiaryAct,
  setPutdata,
  putdata,
  setBodydata,
  calculation,
}: any) => {
  const { TargetDiary } = useSelector((state: RootState) => state.post);
  let [feedList, setFeedList] = useState<any>([]);
  let [ischecked, setIschecked] = useState<any>(false);
  const [inputValues, setInputValues] = useState<any>({
    feedName: { diaryContentId: 0, value: "", writable: "Y" },
    feedWeight: { diaryContentId: 0, value: "", writable: "Y" },
    boxFeedWeight: { diaryContentId: 0, value: "", writable: "Y" },
    // feedTime: { diaryContentId: 0, value: "", writable: "Y" },
    // lastfeedTime: { diaryContentId: 0, value: "", writable: "Y" },
    boxWeight: { diaryContentId: 0, value: "", writable: "Y" },
    expAmount: { diaryContentId: 0, value: "", writable: "Y" },
    feedTotalCount: { diaryContentId: 0, value: "", writable: "Y" },
  });

  useEffect(() => {
    putdata &&
      putdata.map((item: any, idx: Number) => {
        Object.keys(inputValues).map((inputkey) => {
          if (item.diaryItem.name === inputkey) {
            let updatedInputValues = { ...inputValues };
            console.log("item :: ", item.diaryItem);

            updatedInputValues[inputkey].diaryContentId = item.diaryContentId;
            updatedInputValues[inputkey].value = item.value;
            updatedInputValues[inputkey].diaryItem = item.diaryItem;
            setInputValues(updatedInputValues);
            setBodydata({ ...inputValues });

            console.log("inputValues::: ", inputValues);

            if (item.value === "1" && item.diaryItem.name === "feedTime") {
              let updatedInputValues = { ...inputValues };
              updatedInputValues[inputkey].diaryContentId = item.diaryContentId;
              updatedInputValues[inputkey].value = true;
              setInputValues(updatedInputValues);
              setBodydata({ ...inputValues });
            } else if (
              item.value === "0" &&
              item.diaryItem.name === "feedTime"
            ) {
              let updatedInputValues = { ...inputValues };
              updatedInputValues[inputkey].diaryContentId = item.diaryContentId;
              updatedInputValues[inputkey].value = false;
              setInputValues(updatedInputValues);
              setBodydata({ ...inputValues });
            }

            if (item.value === "1" && item.diaryItem.name === "lastfeedTime") {
              let updatedInputValues = { ...inputValues };
              updatedInputValues[inputkey].diaryContentId = item.diaryContentId;
              updatedInputValues[inputkey].value = true;
              setInputValues(updatedInputValues);
              setBodydata({ ...inputValues });
            } else if (
              item.value === "0" &&
              item.diaryItem.name === "lastfeedTime"
            ) {
              let updatedInputValues = { ...inputValues };
              updatedInputValues[inputkey].diaryContentId = item.diaryContentId;
              updatedInputValues[inputkey].value = false;
              setInputValues(updatedInputValues);
              setBodydata({ ...inputValues });
            }

            console.log("inputValues :: ", inputValues);
          }
        });
      });

    // 사료 리스트 출력
    axios
      .get("ifactory/api/feed")
      .then((res) => {
        setFeedList(res.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, [TargetDiary, putdata, setBodydata]);

  const InputHandler = (e: any) => {
    const { name, value } = e.target;

    setInputValues({
      ...inputValues,
      [name]: { ...inputValues[name], value },
    });
    setBodydata({ ...inputValues });
  };

  const InpuchecktHandler = (e: any) => {
    const { name, value } = e.target;

    if (e.target.name === "feedTime" && e.target.checked === true) {
      setIschecked(true);
    } else {
      setIschecked(false);
    }

    if (e.target.name === "lastfeedTime" && e.target.checked === true) {
      setIschecked(true);
    } else {
      setIschecked(false);
    }

    setInputValues({
      ...inputValues,
      [name]: {
        ...inputValues[name],
        value:
          e.target.checked === null && undefined ? false : e.target.checked,
      },
    });
  };
  useEffect(() => {
    setBodydata({ ...inputValues });
  }, [inputValues, setBodydata]);

  let hello = [...feedList];

  let data = {
    feedName: inputValues.feedName.value,
  };

  hello.push(data);

  const result = hello.filter(
    (v, i) => hello.findIndex((x) => x.feedName === v.feedName) === i
  );

  return (
    <styles.WorkItemBox>
      <styles.WorkItem>
        {/* {console.log("inputValues", inputValues)} */}
        <div className="work-item-top">
          <p className="work-item-title">사료이름</p>
        </div>
        <select
          name="feedName"
          value={inputValues?.feedName.value}
          data-Id={putdata?.[0]?.diaryContentId}
          onChange={InputHandler}
        >
          {result &&
            result.map((feed: any, index: number) => {
              return (
                <option key={index} value={feed.feedName}>
                  {feed.feedName}
                </option>
              );
            })}
        </select>
      </styles.WorkItem>
      <styles.WorkItem>
        <div className="work-item-top">
          <p className="work-item-title">
            {/* 개체예상마리수 */} {inputValues.expAmount.diaryItem?.note}
          </p>
          <p className="work-item-unit">
            {/* (마리) */} {inputValues.expAmount.diaryItem?.unit}
          </p>
        </div>
        <input
          type="text"
          style={{
            background:
              inputValues?.expAmount?.diaryItem?.writable === "N"
                ? "#dddddd"
                : "transparent",
          }}
          value={inputValues?.expAmount.value}
          data-Id=""
          name="expAmount"
          onChange={InputHandler}
          readOnly={inputValues?.expAmount?.diaryItem?.writable !== "Y"}
        />
      </styles.WorkItem>
      <styles.WorkItem>
        <div className="work-item-top">
          <p className="work-item-title">
            {/* 급이량 */} {inputValues.feedWeight.diaryItem?.note}
          </p>
          <p className="work-item-unit">
            {" "}
            {inputValues.feedWeight.diaryItem?.unit}
          </p>
        </div>
        <input
          type="text"
          style={{
            background:
              inputValues?.feedWeight?.diaryItem?.writable === "N"
                ? "#dddddd"
                : "transparent",
          }}
          value={inputValues?.feedWeight?.value}
          data-Id=""
          name="feedWeight"
          onChange={InputHandler}
          readOnly={inputValues?.feedWeight?.diaryItem?.writable !== "Y"}
        />
      </styles.WorkItem>
      <styles.WorkItem>
        <div className="work-item-top">
          <p className="work-item-title">
            {/* 급이 후 무게" */} {inputValues.boxFeedWeight.diaryItem?.note}
          </p>
          <p className="work-item-unit">
            {" "}
            {inputValues.boxFeedWeight.diaryItem?.unit}
          </p>
        </div>
        <input
          type="text"
          style={{
            background:
              inputValues?.boxFeedWeight?.diaryItem?.writable === "N"
                ? "#dddddd"
                : "transparent",
          }}
          value={inputValues.boxFeedWeight.value}
          data-Id=""
          name="boxFeedWeight"
          onChange={InputHandler}
          readOnly={inputValues?.boxFeedWeight?.diaryItem?.writable !== "Y"}
        />
      </styles.WorkItem>

      <styles.WorkItem>
        <div className="work-item-top">
          <p className="work-item-title">
            {/* 급이누적횟수 */} {inputValues.feedTotalCount.diaryItem?.note}
          </p>
          <p className="work-item-unit">
            {/* (회) */} {inputValues.feedTotalCount.diaryItem?.unit}
          </p>
        </div>
        <input
          type="text"
          style={{
            background:
              inputValues?.feedTotalCount?.diaryItem?.writable === "N"
                ? "#dddddd"
                : "transparent",
          }}
          value={inputValues.feedTotalCount.value}
          data-Id=""
          name="feedTotalCount"
          onChange={InputHandler}
          readOnly={inputValues?.feedTotalCount?.diaryItem?.writable !== "Y"}
        />
      </styles.WorkItem>

      <styles.WorkItem>
        <div className="work-item-top">
          <p className="work-item-title">
            {/* 급이전상자무게 */} {inputValues.boxWeight.diaryItem?.note}
          </p>
          <p className="work-item-unit">
            {" "}
            {inputValues.boxWeight.diaryItem?.unit}
          </p>
        </div>
        <input
          type="text"
          style={{
            background:
              inputValues?.boxWeight?.diaryItem?.writable === "N"
                ? "#dddddd"
                : "transparent",
          }}
          value={inputValues.boxWeight.value}
          data-Id=""
          name="boxWeight"
          onChange={InputHandler}
          readOnly={inputValues?.boxWeight?.diaryItem?.writable !== "Y"}
        />
      </styles.WorkItem>

      {/* 
      <styles.CleaningCheckBox>
        <styles.WorkItem>
          <label>
            <input
              id="feedTime"
              checked={inputValues.feedTime.value === true ? true : false}
              value=""
              type="checkbox"
              // data-Id={parseInt(putdata?.[0]?.diaryContentId)}
              data-Id=""
              name="feedTime"
              onChange={InpuchecktHandler}
            />
            {inputValues?.feedTime?.diaryItem?.note}
          </label>
        </styles.WorkItem>
      </styles.CleaningCheckBox>

      <styles.CleaningCheckBox>
        <styles.WorkItem>
          <label>
            MainPage<input
              id="lastfeedTime"
              checked={inputValues.lastfeedTime.value === true ? true : false}
              value=""
              type="checkbox"
              data-Id=""
              name="lastfeedTime"
              onChange={InpuchecktHandler}
            />
            {inputValues.lastfeedTime?.diaryItem?.note}
          </label>
        </styles.WorkItem>
      </styles.CleaningCheckBox>
       */}
    </styles.WorkItemBox>
  );
};

const DISEASE = ({
  setPutdata,
  putdata,
  setBodydata,
  deleteOccurImage,
  setDeleteOccurImage,
  uploadOccurImage,
  setUploadOccurImage,
  deleteDeathImage,
  setDeleteDeathImage,
  uploadDeathImage,
  setUploadDeathImage,
}: any) => {
  const { TargetDiary } = useSelector((state: RootState) => state.post);

  const [imageSrc2, setImageSrc2] = useState<any>([]);
  const [ImageTotal2, setImageTotal2] = useState(0);
  const [imageSrc3, setImageSrc3] = useState<any>([]);
  const [ImageTotal3, setImageTotal3] = useState(0);
  const [serachparams] = useSearchParams();
  // 발병이미지
  let [getOccurImage, setGetOccurImage] = useState<any>(); // 받아온 이미지
  let [imageOccurSrc, setImageOccurSrc] = useState<any>([]); // 미리보기 이미지
  // 곤충 폐사 이미지
  let [getDeathImage, setGetDeathImage] = useState<any>(); // 받아온 이미지
  let [imageDeathSrc, setImageDeathSrc] = useState<any>([]); // 미리보기 이미지

  const [inputValues, setInputValues] = useState<any>({
    diseaseCount: {
      diaryContentId: 0,
      value: "",
      writable: "Y",
      unit: 0,
      note: "",
    },
    wormDeadWeight: {
      diaryContentId: 0,
      value: "",
      writable: "Y",
      unit: 0,
      note: "",
    },
  });

  useEffect(() => {
    putdata &&
      putdata.map((item: any, idx: Number) => {
        Object.keys(inputValues).map((inputkey) => {
          if (item.diaryItem.name === inputkey) {
            let updatedInputValues = { ...inputValues };
            updatedInputValues[inputkey].diaryContentId = item.diaryContentId;
            updatedInputValues[inputkey].value = item.value;
            updatedInputValues[inputkey].diaryItem = item.diaryItem;
            setInputValues(updatedInputValues);
            setBodydata({ ...inputValues });
          }
        });
      });

    setGetOccurImage(
      TargetDiary?.files.filter(
        (v: any) => v.group === `pest-${serachparams.get("id")}`
      )
    );
    setGetDeathImage(
      TargetDiary?.files.filter(
        (v: any) => v.group === `pestSample-${serachparams.get("id")}`
      )
    );
  }, [TargetDiary, inputValues, putdata, serachparams, setBodydata]);

  const InputHandler = (e: any) => {
    const { name, value } = e.target;
    setInputValues({
      ...inputValues,
      [name]: { ...inputValues[name], value },
    });
    setBodydata({ ...inputValues });
  };
  useEffect(() => {
    setBodydata({ ...inputValues });
  }, [inputValues, setBodydata]);

  useEffect(() => {
    setImageTotal2(imageSrc2.length);
  }, [imageSrc2]);
  useEffect(() => {
    setImageTotal3(imageSrc3.length);
  }, [imageSrc3]);

  const DiseaseImageController = (Image: any) => {
    if (Image.target.id === "Occur") {
      setUploadOccurImage([...uploadOccurImage, Image.target.files[0]]);
      if (imageOccurSrc.length >= 10) {
        alert("이미지는 최대 10장까지 등록 가능합니다.");
      } else {
        const reader = new FileReader();
        reader.onload = () => {
          setImageOccurSrc([...imageOccurSrc, reader.result]);
        };
        reader.readAsDataURL(Image.target.files[0]);
      }
    }
    if (Image.target.id === "Death") {
      setUploadDeathImage([...uploadDeathImage, Image.target.files[0]]);
      if (imageDeathSrc.length >= 10) {
        alert("이미지는 최대 10장까지 등록 가능합니다.");
      } else {
        const reader = new FileReader();
        reader.onload = () => {
          setImageDeathSrc([...imageDeathSrc, reader.result]);
        };
        reader.readAsDataURL(Image.target.files[0]);
      }
    }
  };

  const ImageHide = (e: any) => {
    console.log("내가확인할e", e);
    if (e.name) {
      setDeleteOccurImage([...deleteOccurImage, e.name]);
    }
    imageOccurSrc.map((Image: any, idx: any) => {
      if (e === Image) {
        setImageOccurSrc(
          imageOccurSrc.filter((v: any, i: number) => i !== idx)
        );
        setUploadOccurImage(
          uploadOccurImage.filter((v: any, i: number) => i !== idx)
        );
      }
    });
    getOccurImage.map((Image: any, idx: number) => {
      console.log("확인할이미지", Image);
      if (e.name === Image.name) {
        setGetOccurImage(
          getOccurImage.filter((v: any, i: number) => i !== idx)
        );
      }
    });
  };
  const ImageHide2 = (e: any) => {
    if (e.name) {
      setDeleteDeathImage([...deleteDeathImage, e.name]);
    }
    imageDeathSrc.map((Image: any, idx: any) => {
      if (e === Image) {
        setImageDeathSrc(
          imageDeathSrc.filter((v: any, i: number) => i !== idx)
        );
        setUploadDeathImage(
          uploadDeathImage.filter((v: any, i: number) => i !== idx)
        );
      }
    });
    getDeathImage.map((Image: any, idx: number) => {
      if (e.name === Image.name) {
        setGetDeathImage(
          getDeathImage.filter((v: any, i: number) => i !== idx)
        );
      }
    });
  };
  useEffect(() => {
    console.log(TargetDiary);
  }, []);
  return (
    <styles.WorkItemBox>
      <styles.DiseaseItem>
        <div className="disease-top">
          <p className="disease-title">
            {/* 발현두수 */}
            {inputValues.diseaseCount.diaryItem?.note}
          </p>
          <p className="disease-unit">
            {/* (개수) */} {inputValues.diseaseCount.diaryItem?.unit}
          </p>
          <input
            type="text"
            style={{
              background:
                inputValues?.diseaseCount?.diaryItem?.writable === "N"
                  ? "#dddddd"
                  : "transparent",
            }}
            value={inputValues.diseaseCount.value}
            name="diseaseCount"
            data-Id=""
            onChange={InputHandler}
            readOnly={inputValues?.diseaseCount?.diaryItem?.writable !== "Y"}
          />
        </div>
      </styles.DiseaseItem>
      <styles.ImageUpload>
        <p className="disease-img-title">발병사진</p>
        <label htmlFor="Occur">
          <div className="camera-btn">
            <p className="camera-img">
              <img src="./img/camera.svg" />
            </p>
            <p className="total-img">{ImageTotal2}/10</p>
          </div>
        </label>
        <input
          type="file"
          id="Occur"
          accept="image/jpg, image/png, image/jpeg"
          onChange={(e: any) => DiseaseImageController(e)}
        />
        {imageOccurSrc.map((Image: any, idx: any) => {
          return (
            <styles.PreviewIamge>
              <p
                onClick={() => {
                  ImageHide(Image);
                }}
              >
                <img src="./img/X.svg" />
              </p>
              <img src={Image} alt={idx} />
            </styles.PreviewIamge>
          );
        })}
        {getOccurImage?.map((Image: any, idx: any) => {
          return (
            <styles.PreviewIamge>
              <p
                onClick={() => {
                  ImageHide(Image);
                }}
              >
                <img src="./img/X.svg" />
              </p>
              <img
                src={`https://ifactoryfarm.farminsf.com/back/ifactroy/api/file/downloadfile/${Image.name}`}
                alt={idx}
              />
            </styles.PreviewIamge>
          );
        })}
      </styles.ImageUpload>

      <styles.DiseaseItem>
        <div className="disease-top">
          <p className="disease-tiNPMtle">
            {/* 곤충폐사무게 */} {inputValues.wormDeadWeight.diaryItem?.note}
          </p>
          <p className="disease-unit">
            {/* (g) */} {inputValues.wormDeadWeight.diaryItem?.unit}
          </p>
          <input
            type="text"
            style={{
              background:
                inputValues?.wormDeadWeight?.diaryItem?.writable === "N"
                  ? "#dddddd"
                  : "transparent",
            }}
            value={inputValues.wormDeadWeight.value}
            name="wormDeadWeight"
            data-Id=""
            onChange={InputHandler}
            readOnly={inputValues?.wormDeadWeight?.diaryItem?.writable !== "Y"}
          />
        </div>
      </styles.DiseaseItem>
      <styles.ImageUpload>
        <p className="disease-img-title">곤충폐사 샘플사진</p>
        <label htmlFor="Death">
          <div className="camera-btn">
            <p className="camera-img">
              <img src="./img/camera.svg" />
            </p>
            <p className="total-img">{ImageTotal3}/10</p>
          </div>
        </label>
        <input
          type="file"
          id="Death"
          accept="image/jpg, image/png, image/jpeg"
          onChange={(e: any) => DiseaseImageController(e)}
        />
        {imageDeathSrc.map((Image: any, idx: any) => {
          return (
            <styles.PreviewIamge>
              <p
                onClick={() => {
                  ImageHide2(Image);
                }}
              >
                <img src="./img/X.svg" />
              </p>
              {/* <img src={`http://192.168.10.55:23500/ifactroy/api/file/downloadfile/${Image.name}`} alt={idx} /> */}
              <img src={Image} alt={idx} />
            </styles.PreviewIamge>
          );
        })}
        {getDeathImage?.map((Image: any, idx: any) => {
          return (
            <styles.PreviewIamge>
              <p
                onClick={() => {
                  ImageHide2(Image);
                }}
              >
                <img src="./img/X.svg" />
              </p>
              <img
                src={`https://ifactoryfarm.farminsf.com/back/ifactroy/api/file/downloadfile/${Image.name}`}
                alt={idx}
              />
            </styles.PreviewIamge>
          );
        })}
      </styles.ImageUpload>
    </styles.WorkItemBox>
  );
};
export default { GROWTH, REPLACEFEED, CLEAN, FEED, DISEASE };
